<div class="global-loader" [class.global-loader--visible]="isLoading()">
    <div class="global-loader__backdrop"></div>
    <div class="global-loader__spinner">
        <mat-spinner diameter="52" strokeWidth="4"></mat-spinner>
    </div>
</div>
<sidenav>
    <router-outlet></router-outlet>
</sidenav>